export enum TrackingEvents {
    ADD_TO_WISHLIST = 'add_to_wishlist',
    REMOVE_FROM_WISHLIST = 'remove_from_wishlist',
    ADD_TO_CART = 'add_to_cart',
    REMOVE_FROM_CART = 'remove_from_cart',
    PAGE_VIEW = 'page_view',
    VIEW_ITEM = 'view_item',
    TAB_CLICK = 'tab_click',
    SUBMIT_SEARCH = 'submit_search',
    VIEW_SEARCH_RESULTS = 'view_search_results',
    LEGACY_SEARCH = 'Search',
    ERROR = 'error',
}
